<template>
  <button
    class="button"
    :class="{
      gray,
      secondary,
      outline,
      disable,
      full,
      half,
      rounded,
      flexable,
    }"
    :style="{ '--color': color }"
    :disabled="disable"
  >
    <div class="text">{{ text }}</div>
  </button>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'Button',
  props: {
    text: {
      type: String,
      default: '按鈕',
    },
    gray: {
      type: Boolean,
      default: false,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
    half: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    flexable: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const store = useStore();
    const color = computed(() => store.getters.getColor(1));

    return {
      color,
    };
  },
};
</script>

<style lang="scss" scoped>
.button {
  position: relative;
  background: none;
  background-color: var(--color);
  border-radius: 8px;
  height: 45px;
  display: inline-flex;
  box-sizing: border-box;
  outline: none;
  box-shadow: none;
  border: none;
  padding: 0 27px;

  &.flexable {
    height: 100%;
    width: 100%;
    padding: 0;
  }

  &:active,
  &:focus {
    border: none;
  }

  .text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #eeeeee;
  }

  &.gray {
    background-color: var(--gray);
    .text {
      color: #ffffff;
    }
  }

  &.secondary {
    background-color: var(--secondary);
    .text {
      color: #333333;
    }
  }

  &.full {
    letter-spacing: 5px;
    width: 100%;
    height: 40px;
    padding: 0;
  }

  &.half {
    letter-spacing: 5px;
    width: 50%;
    height: 40px;
    padding: 0;
  }

  &.outline {
    border: 1px solid var(--color);
    box-sizing: border-box;
    border-radius: 25px;
    background-color: transparent;

    .text {
      font-weight: normal;
      color: var(--color);
    }
  }

  &.rounded {
    border-radius: 25px;
  }

  &.disable {
    background: #cccccc;

    &.outline {
      background: transparent;
      border: 1px solid #888888;
      .text {
        color: #888888;
      }
    }
  }
}
</style>
